import classnames from 'classnames';
import type { ChangeEvent, FunctionComponent } from 'react';

import { RadioSelectItem } from './components/RadioSelectItem/RadioSelectItem';
import type { Item } from './interfaces';

import styles from './RadioSelect.module.scss';

interface Props {
  items: Item[];
  className?: string;
  onChange?(event: ChangeEvent<HTMLInputElement>, item: Item): void;
  id?: string;
  testId?: string;
}

const nbItemsToDisplay = parseInt(styles.nbItemsToDisplay, 10);

export const RadioSelect: FunctionComponent<Props> = ({
  className,
  items,
  onChange,
  id = 'default',
  testId = 'default',
}) => {
  const rootClassnames = classnames(styles.root, className, {
    [styles.withScrollbar]: items.length > nbItemsToDisplay,
  });

  const handleClick = (
    event: ChangeEvent<HTMLInputElement>,
    selectedValue: string,
  ) => {
    if (onChange) {
      const item = items.find(({ value }) => value === selectedValue);
      if (item && !item?.active) {
        onChange(event, item);
      }
    }
  };

  return (
    <div className={rootClassnames} data-testid={`RadioSelect-${testId}`}>
      {items.map((item) => (
        <RadioSelectItem
          key={`${item.label}_${item.value}`}
          label={item.label}
          value={item.value}
          active={item.active}
          onClick={handleClick}
          id={id}
          testId={testId}
          className={styles.item}
          count={item.count}
        />
      ))}
    </div>
  );
};

RadioSelect.displayName = 'RadioSelect';
